import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importez vos fichiers de traduction directement depuis src/locales
import enDashboard from './locales/en/dashboard.json';
import frDashboard from './locales/fr/dashboard.json';
import enSidebar from './locales/en/sidebar.json';
import frSidebar from './locales/fr/sidebar.json';
import frEnterprises from './locales/fr/enterprises.json';
import enEnterprises from './locales/en/enterprises.json';
import enPaginateBox from './locales/en/paginate_box.json';
import frPaginateBox from './locales/fr/paginate_box.json';
import frAddEnterprise from './locales/fr/add_enterprise.json';
import enAddEnterprise from './locales/en/add_enterprise.json';
import frEmployesByEnterprise from './locales/fr/employes_by_enterprise.json';
import enEmployesByEnterprise from './locales/en/employes_by_enterprise.json';
import enAddEmployer from './locales/en/add_employer.json';
import frAddEmployer from './locales/fr/add_employer.json';
import frReports from './locales/fr/reports.json';
import enReports from './locales/en/reports.json';
import enStats from './locales/en/stats.json';
import frStats from './locales/fr/stats.json';
import frDemands from './locales/fr/demands.json';
import enDemands from './locales/en/demands.json';
import enReportsDoc from './locales/en/reports_doc.json';
import frReportsDoc from './locales/fr/reports_doc.json';
import frAddSpyEnterprise from './locales/fr/add_spy_enterprise.json';
import enAddSpyEnterprise from './locales/en/add_spy_enterprise.json';
import enEmployerList from './locales/en/employer_list.json';
import frEmployerList from './locales/fr/employer_list.json';
import frZonesList from './locales/fr/zones_list.json';
import enZonesList from './locales/en/zones_list.json';
import enMissionsList from './locales/en/missions_list.json';
import frMissionsList from './locales/fr/missions_list.json';
import enAddMission from './locales/en/add_mission.json';
import frAddMission from './locales/fr/add_mission.json';
import frAddZone from './locales/fr/add_zone.json';
import enAddZone from './locales/en/add_zone.json';
import enTasksList from './locales/en/tasks_list.json';
import frTasksList from './locales/fr/tasks_list.json';
import frAddTask from './locales/fr/add_task.json';
import enAddTask from './locales/en/add_task.json';
import enAddTaskEnterprise from './locales/en/add_task_enterprise.json';
import frAddTaskEnterprise from './locales/fr/add_task_enterprise.json';
import frComptes from './locales/fr/comptes.json';
import enComptes from './locales/en/comptes.json';
import enUpdateUserInformations from './locales/en/update_user_informations.json';
import frUpdateUserInformations from './locales/fr/update_user_informations.json';
import enAddUser from './locales/en/add_user.json';
import frAddUser from './locales/fr/add_user.json';
import frAdminComptes from './locales/fr/admin_comptes.json';
import enAdminComptes from './locales/en/admin_comptes.json';
import enRequests from './locales/en/requests.json';
import frRequests from './locales/fr/requests.json';
import frRoles from './locales/fr/roles.json';
import enRoles from './locales/en/roles.json';
import enAddRole from './locales/en/add_role.json';
import frAddRole from './locales/fr/add_role.json';
import frSignIn from './locales/fr/sign_in.json';
import enSignIn from './locales/en/sign_in.json';
import enAccountMenu from './locales/en/account_menu.json';
import frAccountMenu from './locales/fr/account_menu.json';
import enNotifications from './locales/en/notifications.json';
import frNotifications from './locales/fr/notifications.json';
import frAddContract from './locales/fr/add_contract.json';
import enAddContract from './locales/en/add_contract.json';
import frGeoAccessBanner from './locales/fr/geo_access_banner.json';
import enGeoAccessBanner from './locales/en/geo_access_banner.json';

// Définissez les ressources de traduction
const resources = {
  en: {
    dashboard: enDashboard,
    sidebar: enSidebar,
    enterprises: enEnterprises,
    paginate_box: enPaginateBox,
    add_enterprise: enAddEnterprise,
    employes_by_enterprise: enEmployesByEnterprise,
    add_employer: enAddEmployer,
    reports: enReports,
    stats: enStats,
    demands: enDemands,
    reports_doc: enReportsDoc,
    add_spy_enterprise: enAddSpyEnterprise,
    employer_list: enEmployerList,
    zones_list: enZonesList,
    missions_list: enMissionsList,
    add_mission: enAddMission,
    add_zone: enAddZone,
    tasks_list: enTasksList,
    add_task: enAddTask,
    add_task_enterprise: enAddTaskEnterprise,
    comptes: enComptes,
    update_user_informations: enUpdateUserInformations,
    add_user: enAddUser,
    admin_comptes: enAdminComptes,
    requests: enRequests,
    roles: enRoles,
    add_role: enAddRole,
    sign_in: enSignIn,
    account_menu: enAccountMenu,
    notifications: enNotifications,
    add_contract: enAddContract,
    geo_access_banner: enGeoAccessBanner,
  },
  fr: {
    dashboard: frDashboard,
    sidebar: frSidebar,
    enterprises: frEnterprises,
    paginate_box: frPaginateBox,
    add_enterprise: frAddEnterprise,
    employes_by_enterprise: frEmployesByEnterprise,
    add_employer: frAddEmployer,
    reports: frReports,
    stats: frStats,
    demands: frDemands,
    reports_doc: frReportsDoc,
    add_spy_enterprise: frAddSpyEnterprise,
    employer_list: frEmployerList,
    zones_list: frZonesList,
    missions_list: frMissionsList,
    add_mission: frAddMission,
    add_zone: frAddZone,
    tasks_list: frTasksList,
    add_task: frAddTask,
    add_task_enterprise: frAddTaskEnterprise,
    comptes: frComptes,
    update_user_informations: frUpdateUserInformations,
    add_user: frAddUser,
    admin_comptes: frAdminComptes,
    requests: frRequests,
    roles: frRoles,
    add_role: frAddRole,
    sign_in: frSignIn,
    account_menu: frAccountMenu,
    notifications: frNotifications,
    add_contract: frAddContract,
    geo_access_banner: frGeoAccessBanner,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: true,

    interpolation: {
      escapeValue: false,
    },

    ns: [
      'dashboard',
      'sidebar',
      'enterprises',
      'paginate_box',
      'add_enterprise',
      'employes_by_enterprise',
      'add_employer',
      'reports',
      'stats',
      'demands',
      'reports_doc',
      'add_spy_enterprise',
      'employer_list',
      'zones_list',
      'missions_list',
      'add_mission',
      'add_zone',
      'tasks_list',
      'add_task',
      'add_task_enterprise',
      'comptes',
      'update_user_informations',
      'add_user',
      'admin_comptes',
      'requests',
      'roles',
      'add_role',
      'sign_in',
      'account_menu',
      'notifications',
      'add_contract',
      'geo_access_banner',
    ], // Ajoutez les namespaces que vous utilisez
    defaultNS: 'dashboard',
  });

export default i18n;
